namespace GeniuzPOS.PosShift {
    export namespace PsTaxInvoiceDtService {
        export const baseUrl = 'PosShift/PsTaxInvoiceDt';

        export declare function Create(request: Serenity.SaveRequest<PsTaxInvoiceDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsTaxInvoiceDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsTaxInvoiceDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsTaxInvoiceDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/PsTaxInvoiceDt/Create",
            Update = "PosShift/PsTaxInvoiceDt/Update",
            Delete = "PosShift/PsTaxInvoiceDt/Delete",
            Retrieve = "PosShift/PsTaxInvoiceDt/Retrieve",
            List = "PosShift/PsTaxInvoiceDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsTaxInvoiceDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
